export const useScrollToFirstError = (ref: React.RefObject<HTMLElement | null>) => {
  let observer: MutationObserver | null;

  const scrollToError = () => {
    const firstErrorElement = ref.current?.querySelector(".border-container.error,[aria-invalid=true]");

    if (firstErrorElement) {
      firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });

      // Remove the observer after scrolling to the first error to not keep scrolling during interaction
      observer?.disconnect();
    }
  };

  const observe = () => {
    if (ref.current === null) {
      return;
    }

    observer = new MutationObserver(scrollToError);
    observer.observe(ref.current, { attributes: true, childList: true, subtree: true });

    // Initial scroll to the first error when the observer is set up
    scrollToError();
  };

  return {
    scrollToFirstError: observe,
  };
};
